import { z } from 'zod';
import { assetSchema, audioTrackSchema, formatSchema, metadataSchema, responsiveCompositionSchema, sceneSchema, } from './project';
export const projectSchema = z.object({
    version: z.string().default('1.0'),
    schemaVersion: z.number().int().positive().default(1),
    id: z.string().min(1),
    metadata: metadataSchema,
    format: formatSchema,
    style: z
        .object({
        preset: z.string().default('cinematic-documentary'),
    })
        .default({ preset: 'cinematic-documentary' }),
    assets: z.array(assetSchema).default([]),
    scenes: z.array(sceneSchema).default([]),
    audio: z
        .object({
        tracks: z.array(audioTrackSchema).default([]),
    })
        .default({ tracks: [] }),
    responsive: z.array(responsiveCompositionSchema).default([]),
    output: z.record(z.unknown()).default({}),
});
//# sourceMappingURL=video-project.js.map